// import React, { useRef, useState } from 'react'
// import { FiMenu, FiUser, FiX } from 'react-icons/fi';
// import { NavLink, Outlet, useNavigate } from 'react-router-dom';

// const Dashboard = () => {
//     // const tabs = ["Home", "Report", "Analysis"];
//      const tabs = [

//         { name: "Home", to: "/dashboard/home" },

//         { name: "Report", to: "/dashboard/report" },
//         { name: "Analysis", to: "/dashboard/analysis" },

//     ];

//     const [activeTab, setActiveTab] = useState("home")

//     const popupRef = useRef(null);
//     const [menuOpen, setMenuOpen] = useState(false);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [showProfile, setShowProfile] = useState(false);
//     const [showSetting, setShowSettings] = useState(false);
//     const [showLogout, setShowLogout] = useState(false)
//     const [status, setStatus] = useState("success");
//     const [logoutMessage, setLogoutMessage] = useState("");
//     const [showPopup, setShowPopup] = useState(false);
//     const navigate = useNavigate();
//     // const { getLoginToken, getGoogleAuthToken } = useAuth();
//     const [showMore, setShowMore] = useState(false);
//     const toggleShowMore = () => setShowMore(prev => !prev);

//     const [isLoggingOut, setIsLoggingOut] = useState(false);

//     const [show, setShow] = useState(false);
//     const [selectedAccount, setSelectedAccount] = useState("demo");

// const adminMail = localStorage.getItem("admin_mail");

//    return (
//     <div>
//     <div>Hello</div>
//     <div className='relative h-screen w-screen '>

//                     {/* Fixed Navbar */}

//                     <nav className="fixed top-0 left-0 right-0 flex items-center

//                           z-50 px-6 h-16 bg-mylightbg dark:bg-mytextlight
//                            border backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)]
//                             border-[rgba(255,255,255,0.2)] bg-[rgba(56,56,56,0.1)]">

//                         <div className="w-full flex justify-between items-center ">
//                             {/* Desktop Menu */}

//                             <div className="hidden md:flex space-x-4 lg:space-x-6">

//                                 {/* //update code  */}

//                                 {/* {token && (
//                                     <> */}

//                                 {tabs.map((tab) => (
//                                     <NavLink
//                                         key={tab.to}
//                                         to={tab.to}
//                                         className={({ isActive }) =>

//                                             ` no-underline px-4 py-2 font-semibold border-b-2 transition-colors duration-200 ${isActive
//                                                 ? "border-blue-500 text-blue-600"
//                                                 : "border-transparent text-mytextlight dark:text-mytextdark hover:text-blue-500"
//                                             }`
//                                         }
//                                     >
//                                         {tab.name.toUpperCase()}
//                                     </NavLink>
//                                 ))}
//                                 {/*
//                                     </>

//                                 )} */}

//                             </div>

//                             {/* Middle Section */}

//                             <div className=" flex w-full max-w-xl justify-between items-center md:ml-0 md:space-x-6 md:justify-end
//  ">

//                                 <div className="relative  ">
//                                     <div
//                                         onClick={() => setDropdownOpen(!dropdownOpen)}
//                                         className="w-10 h-10 rounded-full bg-gray-500 border-2 border-white flex items-center justify-center cursor-pointer "
//                                     >
//                                         {/* <img src="/assets/profile.png" alt="profile" className="w-9 h-9 rounded-full" /> */}
//                                         <span className="text-white text-2xl font-semibold ">
//                                             {adminMail.charAt(0).toUpperCase() || "?"}
//                                         </span>

//                                     </div>

//                                     {/* Dropdown Menu */}
//                                     {dropdownOpen && (
//                                         <div className="absolute right-0 left-auto  mt-3 w-48  max-w-[90vw]

//                                         bg-white/95  dark:bg- dark:bg-mydarkbg rounded-md  text-mytextlight dark:text-mytextdark  ">
//                                             <button
//                                                 onClick={() => {
//                                                     setShowProfile((prev) => !prev)
//                                                     setDropdownOpen(false)
//                                                 }}
//                                                 className="flex items-center px-4 py-2 text-sm  hover:bg-gray-300 w-full"
//                                             >
//                                                 <FiUser className="w-5 h-5 mr-2" />
//                                                 Profile
//                                             </button>

//                                             {/* <button
//                                             onClick={() => setShowSettings(!showSetting)}
//                                             className="flex items-center px-4 py-2 text-sm text-black hover:bg-gray-300 w-full"
//                                         >
//                                             <FiSettings className="w-5 h-5 mr-2" />
//                                             Settings
//                                         </button> */}

//                                             <div

//                                                 className="flex items-center  px-4 py-2 text-sm  hover:bg-gray-300 w-full  "
//                                             >
//                                                 {/* < ThemeToggleLeft /> */}

//                                             </div>

//                                             {/* <button
//                                                 onClick={handleLogout}
//                                                 disabled={isLoggingOut}
//                                                 className={`flex items-center px-4 py-2 text-sm  hover:bg-gray-300 w-full ${isLoggingOut ? 'opacity-50 cursor-not-allowed' : ''}`}
//                                             >
//                                                 {isLoggingOut ? (
//                                                     <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin mr-2"></div>
//                                                 ) : (
//                                                     <FiLogOut className="w-5 h-5 mr-2" />
//                                                 )}
//                                                 {isLoggingOut ? 'Logging out...' : 'Logout'}
//                                             </button> */}

//                                             {/* <div className="bg-mydarkbg dark:bg-mytextdark flex items-center px-2 py-2 text-sm text-mytextdark dark:text-mytextlight hover:bg-gray-300 w-full  rounded-b-md p-2">
//                                                 <strong>Expiry Date:</strong>
//                                                 <span className="ml-2">{profile.expiry || "xxxxxxx"}</span>
//                                             </div> */}

//                                         </div>
//                                     )}
//                                 </div>

//                                 <div className="  md:hidden  " >
//                                     <button
//                                         onClick={() => setMenuOpen(!menuOpen)}
//                                         className="text-gray-700 focus:outline-none"
//                                     >

//                                         {menuOpen ? (
//                                             <FiX className="h-6 w-6 text-mytextlight dark:text-mytextdark" />
//                                         ) : (
//                                             <FiMenu className="h-6 w-6 text-mytextlight dark:text-mytextdark" />
//                                         )}

//                                     </button>
//                                 </div>

//                             </div>

//                         </div>

//                     </nav>
// {/* // <main>
// //   <Outlet />
// // </main> */}

//      </div>
// </div>

//   )
// }

// export default Dashboard

import React, { useState, useEffect, useRef } from "react";
import {
  FiX,
  FiSettings,
  FiUser,
  FiLogOut,
  FiMenu,
  FiCopy,
} from "react-icons/fi";
import {
  useNavigate,
  NavLink,
  Link,
  useLocation,
  Outlet,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { MdRefresh } from "react-icons/md";

import { useAuth } from "../../context/auth";

import { toast } from "react-toastify";

const Dashboard = () => {
  const popupRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showSetting, setShowSettings] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [status, setStatus] = useState("success");
  const [logoutMessage, setLogoutMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const { getLoginToken, getGoogleAuthToken } = useAuth();
  const [showMore, setShowMore] = useState(false);
  const toggleShowMore = () => setShowMore((prev) => !prev);

  const adminMail = localStorage.getItem("admin_mail");

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [show, setShow] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("demo");

  // useEffect(() => {
  //     const handleClickOutside = (event) => {
  //         if (popupRef.current && !popupRef.current.contains(event.target)) {
  //             setShowProfile(false);
  //         }
  //     };

  //     document.addEventListener('mousedown', handleClickOutside);

  //     return () => {
  //         document.removeEventListener('mousedown', handleClickOutside);
  //     };
  // }, []);

  // const [secKey, setSecKey] = useState([]);

  // const handleLogout = async () => {

  //     setIsLoggingOut(true)

  //     if (!token) {
  //         navigate('/login')
  //         return;
  //     }

  //     try {
  //         const result = await logoutService(token);

  //         if (result.status === 200) {

  //             if (result.data.error === false && result.data.mail_verification_error === false) {

  //                 // First show popup, then redirect after 2.5 seconds
  //                 setTimeout(() => {
  //                     localStorage.removeItem("session-token");
  //                     localStorage.removeItem("login_mail")
  //                     localStorage.removeItem("sec_key")
  //                     localStorage.removeItem("sec_key")
  //                     localStorage.removeItem("session-expiry")
  //                     localStorage.removeItem("hasShownMessage");
  //                     localStorage.removeItem("google_auth_token")
  //                     localStorage.removeItem("user")
  //                    sessionStorage.removeItem("denied");

  //                     logoutCleanup();
  //                     closeWebSocket()
  //                     // console.log("logout successful")
  //                     navigate('/login');
  //                 }, 3000);
  //             }
  //             else {

  //                 toast.error(result?.data?.data)

  //             }

  //         }

  //         else {

  //             toast.error(result?.data?.data)

  //         }

  //     } catch (error) {
  //         toast.error(error.result?.data?.data)
  //     }

  //     finally {
  //         setIsLoggingOut(false);
  //     }
  // };

  // const profRef = useRef(null)
  // useEffect(() => {
  //     function handleClickOutside(event) {
  //         if (profRef.current && !profRef.current.contains(event.target)) {
  //             setDropdownOpen(false); // Close the div
  //         }
  //     }

  //     document.addEventListener("mousedown", handleClickOutside);

  //     return () => {
  //         document.removeEventListener("mousedown", handleClickOutside);
  //     };
  // }, []);

  // const balanceRef = useRef(null)
  // useEffect(() => {
  //     function handleClickOutside(event) {
  //         if (balanceRef.current && !balanceRef.current.contains(event.target)) {
  //             setShow(false); // Close the div
  //         }
  //     }

  //     document.addEventListener("mousedown", handleClickOutside);

  //     return () => {
  //         document.removeEventListener("mousedown", handleClickOutside);
  //     };
  // }, []);

  // const [refreshing, setRefresing] = useState(false);

  // const handleRefreshKey = async () => {

  //     try {

  //         // setDataLoading(true)
  //         setRefresing(true)
  //         const response = await secKeyRefreshService(token);
  //         // responseRef.current = response

  //         if (response.success && response.status === 200) {

  //             toast.success(response?.data?.data)

  //             setSecKey(response.data?.data);
  //             sendGlobalWS({ r: "profile" });

  //             // console.log("respose", response)

  //         }
  //         else {
  //             toast.error(response?.data?.data);
  //             // console.log("respose", response)
  //         }

  //         setTimeout(() => setRefresing(false), 3000);
  //     }
  //     catch (error) {

  //         console.error("error", error?.response)
  //     }

  //     finally {
  //         // setDataLoading(false);
  //         setRefresing(false)
  //     }
  // };

  // useEffect(() => {
  //     let intervalId;

  //     handleRefreshKey();
  // intervalId = setInterval(handleRefreshKey, 10000);

  // return () => {
  //     clearInterval(intervalId);

  // }, []
  // )

  const tabs = [
    { name: "Home", to: "/dashboard/home" },

    { name: "Report", to: "/dashboard/report" },
    { name: "Analysis", to: "/dashboard/analysis" },
  ];

  return (
    <div>
      <div className="relative h-screen w-screen ">
        <div className="min-h-screen  min-w-screen flex flex-col ">
          {/* Fixed Navbar */}

          <nav
            className="fixed top-0 left-0 right-0 flex items-center 
                       
                        
                          z-50 px-6 h-16 bg-mylightbg dark:bg-mytextlight
                           border backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)]
                            border-[rgba(255,255,255,0.2)] bg-[rgba(56,56,56,0.1)]"
          >
            <div className="w-full flex justify-between items-center ">
              {/* Desktop Menu */}

              <div className="hidden md:flex space-x-4 lg:space-x-6">
                {/* //update code  */}

                {/* {token && (
                                    <> */}

                {tabs.map((tab) => (
                  <NavLink
                    key={tab.to}
                    to={tab.to}
                    className={({ isActive }) =>
                      ` no-underline px-4 py-2 font-semibold border-b-2 transition-colors duration-200 ${
                        isActive
                          ? "border-blue-500 text-blue-600"
                          : "border-transparent text-mytextlight dark:text-mytextdark hover:text-blue-500"
                      }`
                    }
                  >
                    {tab.name.toUpperCase()}
                  </NavLink>
                ))}
                {/* 
                                    </>

                                )} */}
              </div>

              {/* Middle Section */}

              {/* 
                                <div className="relative  ">
                                    <div
                                        onClick={() => setDropdownOpen(!dropdownOpen)}
                                        className="w-10 h-10 rounded-full bg-gray-500 border-2 border-white flex items-center justify-center cursor-pointer "
                                    >
                                  
                                        <span className="text-white text-2xl font-semibold ">
                                            {adminMail.charAt(0).toUpperCase() || "?"}
                                        </span>

                                    </div>

                                  
                                    {dropdownOpen && (
                                        <div  className="absolute right-0 left-auto  mt-3 w-48  max-w-[90vw]
                                       

                                        
                                        bg-white/95  dark:bg- dark:bg-mydarkbg rounded-md  text-mytextlight dark:text-mytextdark  ">
                                            <button
                                                onClick={() => {
                                                    setShowProfile((prev) => !prev)
                                                    setDropdownOpen(false)
                                                }}
                                                className="flex items-center px-4 py-2 text-sm  hover:bg-gray-300 w-full"
                                            >
                                                <FiUser className="w-5 h-5 mr-2" />
                                                Profile
                                            </button>

                                          

                                        </div>
                                    )}
                                </div>
 */}

              <div className="  md:hidden  ">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="text-gray-700 focus:outline-none"
                >
                  {menuOpen ? (
                    <FiX className="h-6 w-6 text-mytextlight dark:text-mytextdark" />
                  ) : (
                    <FiMenu className="h-6 w-6 text-mytextlight dark:text-mytextdark" />
                  )}
                </button>
              </div>
            </div>
          </nav>

          <main className="pt-5  px-6 ">
            {/* Mobile Menu */}
            {menuOpen && (
              <div className="absolute z-50 top-16 left-0 right-0 mx-4 text-mytextlight dark:text-mytextlight bg-white  dark:bg-gray-300 shadow-lg rounded-md p-4 space-y-2 animate-slide-down border dark:border-gray-700">
                {tabs.map((tab) => (
                  <NavLink
                    key={tab.to}
                    to={tab.to}
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      `block text-sm font-semibold px-4 py-2 rounded transition-colors duration-200  text-mytextlight dark:text-mytextlight ${
                        isActive
                          ? "text-blue-600 bg-blue-100 dark:bg-gray-400 border-l-4 border-blue-500"
                          : "text-gray-700 dark:text-black hover:bg-gray-100 dark:hover:bg-gray-300"
                      }`
                    }
                  >
                    {tab.name.toUpperCase()}
                  </NavLink>
                ))}
              </div>
            )}

            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
